<!--
 * @Author: wupeiwen <javapeiwen2010@gmail.com>
 * @Date: 2022-06-06 17:50:27
 * @LastEditors: wupeiwen <javapeiwen2010@gmail.com>
 * @LastEditTime: 2022-07-04 12:12:17
 * @FilePath: /jy-dashboard-web/src/components/companyProfile/component-cwh.vue
 * @Description: 茶文化
-->
<template>
  <div class="cwh">
    <div class="content">
      <!-- preload="metadata" -->
      <video class="player" controls autoplay loop muted>
        <source :src="env.VUE_APP_VIDEO" type="video/mp4" />
        Your browser does not support the video tag.
      </video>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    env () {
      return process.env
    }
  }
}
</script>

<style lang="scss">
.cwh {
  padding-top: 52px;
  .content {
    height: 100%;
    position: relative;
    .player {
      height: calc(100% - 12px);
      display: block;
      margin: 6px auto;
    }
  }
}
</style>
